import type { ReactNode } from 'react';

export const symbol_takeout_dining_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M162-80q-15 0-24-11.5t-5-25.5l154-618-1-30q-1-23-15.34-39t-36.5-16q-22.16 0-37.66 14.95Q181-790.1 181-768v41q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-41q0-46.67 32.67-79.33Q186.33-880 233-880h456q45 0 78 30.5t35 75.5l36 662q1 12.95-8.12 22.48Q820.75-80 808-80H162Zm40-60h123l-25-397-98 397Zm183 0h392l-35-631q-2-21-17.04-35T689-820H334q5 13 8 26t4 27l39 627Zm186.5-128.5Q580-277 580-290v-110q26-6 43-27.5t17-49.5v-143q0-8-6-14t-14-6q-8 0-14 6t-6 14v131h-30v-131q0-8-6-14t-14-6q-8 0-14 6t-6 14v131h-30v-131q0-8-6-14t-14-6q-8 0-14 6t-6 14v143q0 28 17 49.5t43 27.5v110q0 13 8.5 21.5T550-260q13 0 21.5-8.5ZM385-140h392-392Z"
		/>
	</svg>
);
